import * as Yup from 'yup';

export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_MAX_LENGTH = 72;

export const PASSWORD_HINT = `Mindestens ${PASSWORD_MIN_LENGTH} Zeichen mit Klein- und Großbuchstabe, Ziffer und Sonderzeichen`;

export const passwordSchema = Yup.string()
  .min(PASSWORD_MIN_LENGTH, `Mindestens ${PASSWORD_MIN_LENGTH} Zeichen`)
  .max(PASSWORD_MAX_LENGTH, `Höchstens ${PASSWORD_MAX_LENGTH} Zeichen`)
  .matches(/\p{Ll}/u, 'Mindestens ein Kleinbuchstabe')
  .matches(/\p{Lu}/u, 'Mindestens ein Großbuchstabe')
  .matches(/\d/, 'Mindestens eine Ziffer')
  .matches(/[^\p{L}\d]/u, 'Mindestens ein Sonderzeichen');
